import { useWeb3ModalProvider } from "@web3modal/ethers/react";
import dateFormat from "dateformat";
import { BrowserProvider, Contract, Interface } from "ethers";
import { useEffect, useState } from "react";
import { fromDecimalData, getContractAddress } from "../common/helper";
import STAKING_ABI from "../common/STAKING_ABI.json";

type Props = {
  apy: number;
  item: any;
  index: number;
};

export const StakingItem = ({ apy, item, index }: Props) => {
  const { walletProvider } = useWeb3ModalProvider();

  const [reward, setReward] = useState<number>(0);
  const [isClaimable, setIsClaimable] = useState<boolean>(false);

  useEffect(() => {
    getTotalReward();
    getClaimable();
  }, [item]);

  const getTotalReward = async () => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const staking = new Contract(
        getContractAddress(apy)!,
        new Interface(STAKING_ABI).format(false),
        signer
      );

      const reward = parseFloat(
        fromDecimalData(await staking.getTotalReward(item.stakingID))
      );

      setReward(reward);
    } catch (err) {
      console.log(err);

      setReward(0);
    }
  };

  const getClaimable = async () => {
    try {
      const provider = new BrowserProvider(walletProvider!);
      const signer = await provider.getSigner();

      const staking = new Contract(
        getContractAddress(apy)!,
        new Interface(STAKING_ABI).format(false),
        signer
      );

      const withdrawableAmount = parseFloat(
        fromDecimalData(await staking.getWithdrawableAmount(item.stakingID))
      );

      setIsClaimable(withdrawableAmount !== 0);
    } catch (err) {
      console.log(err);
      setIsClaimable(false);
    }
  };

  return (
    <tr>
      <td className="text-center">#{index + 1}</td>
      <td className="text-center">{item.account}</td>
      <td className="text-center">{item.amount.toFixed(2)} UPC</td>
      <td className="text-center">{reward.toFixed(2)} UPC</td>
      <td className="text-center">
        {dateFormat(item.stakedAt * 1000, "yyyy-mm-dd HH:MM:ss")}
      </td>
      <td className="text-center">{item.withdrawalAmount.toFixed(2)} UPC</td>
      <td className="text-center">{item.claimedReward.toFixed(2)} UPC</td>
      <td className="text-center">
        {item.lastWithdrawAt
          ? dateFormat(item.lastWithdrawAt, "yyyy-mm-dd HH:MM:ss")
          : ""}
      </td>
      <td className="text-center">
        {isClaimable ? (
          <span className="badge bg-success/10 text-success">Claimable</span>
        ) : item.withdrawalAmount > 0 ? (
          <span className="badge bg-primary/10 text-primary">Claimed</span>
        ) : (
          <span className="badge bg-yellow-100 text-yellow-800">
            Unavailable
          </span>
        )}
      </td>
    </tr>
  );
};
